import { styled } from '@mui/material';

export const ContentStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '1.5rem',
  flexDirection: 'column',
  width: '100%',
}));

export const AlignButtons = styled('div')(({ theme }) => ({
  display: 'flex',
  alignSelf: 'center',
  paddingBottom: '2rem',
}));
